<template>
  <div class="overflow-visible rounded-2xl bg-gradient-to-br from-white/5 to-white/10 p-6 sm:p-8">
    <slot />
  </div>
</template>

<script setup lang="ts">
</script>